import React from "react";
import {useTranslation} from "react-i18next";
import {Stack} from "@mui/material";
import {DateTimeFormatter} from "../../../common/DateTimeFormatter";
import {DetailsTable} from "../../../common/details/DetailsTable";
import {DetailsTextRow} from "../../../common/details/DetailsTextRow";
import {UserTranslKey} from "../UserTranslKey";
import {UserDto} from "../../../client/user/User";
import {PersonTranslKey} from "../../person/PersonTranslKey";

export interface UserInfoPanelProps {
    user: UserDto;
}

export function UserInfoPanel(props: Readonly<UserInfoPanelProps>) {
    const {user} = props;

    const { t } = useTranslation();

    const validFrom = DateTimeFormatter.formatDateTime(user.validityInterval?.validFrom);
    const validTo = DateTimeFormatter.formatDateTime(user.validityInterval?.validTo);

    return (
        <Stack spacing={2} padding={1}>
            <DetailsTable>
                <tbody>
                <DetailsTextRow
                    label={t(UserTranslKey.LOGIN)}
                    value={user.login}
                />

                <DetailsTextRow
                    label={t(UserTranslKey.VALID_FROM)}
                    value={validFrom}
                />
                <DetailsTextRow
                    label={t(UserTranslKey.VALID_TO)}
                    value={validTo}
                />

                <DetailsTextRow
                    label={t(PersonTranslKey.PERSON_FIRSTNAME)}
                    value={user.person?.firstName}
                />
                <DetailsTextRow
                    label={t(PersonTranslKey.PERSON_LASTNAME)}
                    value={user.person?.lastName}
                />
                <DetailsTextRow
                    label={t(PersonTranslKey.PERSON_EMAIL)}
                    value={user.person?.email}
                />
                <DetailsTextRow
                    label={t(PersonTranslKey.PERSON_PHONE)}
                    value={user.person?.phone}
                />
                <DetailsTextRow
                    label={t(PersonTranslKey.PERSON_DATA_ORIGIN)}
                    value={user.person?.dataOrigin}
                />

                <DetailsTextRow
                    label={t(UserTranslKey.USER_IDENTITY_SOURCE)}
                    value={user.identitySource}
                />
                </tbody>
            </DetailsTable>
        </Stack>
    );
}
